import React from 'react';
import { Link } from 'react-router-dom';
import { WarrantyTag } from '../ui/WarrantyTag';
import { buttonClasses } from '../../utils/buttonStyles';
const steps = [{
  title: 'Contact support',
  body: 'Share your order number and a short description or photo of the issue.'
}, {
  title: 'We confirm the defect',
  body: 'Our team reviews the claim against the applicable warranty terms.'
}, {
  title: 'Replacement ships',
  body: 'Covered defects are resolved with a replacement light per warranty terms.'
}];
export function PromiseSection() {
  return <section aria-labelledby="promise-title" className="border-y mf-hairline bg-navy" data-id="element-367" data-mp="3ckorxztw2okq">
      <div className="mx-auto max-w-site px-5 py-10 md:px-8 md:py-14" data-id="element-368" data-mp="37lvci1v1knhx">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr] lg:items-center" data-id="element-369" data-mp="33lbdesqwr9t5">
          <div data-id="element-370" data-mp="1w8rs61pwu8fx">
            <p className="font-display text-lg uppercase tracking-[0.14em] text-titanium" data-id="element-371" data-mp="1w9ksokya01pm">The MarineForce Promise</p>
            <h2 id="promise-title" className="mt-3 font-display text-5xl font-semibold uppercase leading-[0.92] md:text-6xl" data-id="element-372" data-mp="1s5d18g0fo7np">
              Built for the Elements. Backed by MarineForceLED.
            </h2>
            <p className="mt-6 max-w-xl text-xl text-white" data-id="element-373" data-mp="fg4stakqcqoh">
              Professional-grade lighting deserves professional-grade support.
            </p>
            <p className="mt-4 max-w-xl text-titanium" data-id="element-374" data-mp="5hyu11u800nu">
              If a light arrives defective, or experiences a covered failure during its applicable warranty period,
              MarineForceLED provides a replacement according to its warranty terms. Accidental damage, misuse and normal
              wear are not covered.
            </p>
            <div className="mt-8 flex flex-col gap-3 text-sm" data-id="element-375" data-mp="3e0czj53r3xl8">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-376" data-mp="3iyobbldlwi63">
                <span className="w-44 text-titanium/70" data-id="element-377" data-mp="34xbxbfi0aqmu">Systems of 4–24 lights</span>
                <WarrantyTag tier="lifetime" data-id="element-378" data-mp="39wyj4dbwhf79" />
              </div>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-379" data-mp="39w5af6tdsfmh">
                <span className="w-44 text-titanium/70" data-id="element-380" data-mp="1fhi28tnaczwd">1 light &amp; Duo System</span>
                <WarrantyTag tier="oneYear" data-id="element-381" data-mp="1aoyo9vkos2r1" />
              </div>
            </div>
            <div className="mt-10 flex flex-wrap gap-3" data-id="element-382" data-mp="15qf1xu26koy5">
              <Link to="/promise" className={buttonClasses('secondary')} data-id="element-383" data-mp="15ou5u007wxy6">
                Our Promise
              </Link>
              <Link to="/warranty" className={buttonClasses('ghost')} data-id="element-384" data-mp="1yflv0div8mc0">
                Warranty details
              </Link>
            </div>
          </div>

          <ol className="relative space-y-10 border-l border-titanium/20 pl-8" data-id="element-385" data-mp="1th0vkgbfu6om">
            {steps.map((s, i) => <li key={s.title} className="relative" data-id="element-386" data-mp="1ph0h4voc9vhk" data-mpi={i}>
                <span className="absolute -left-[45px] flex h-7 w-7 items-center justify-center rounded-full border border-marine bg-navy text-xs font-semibold text-marine" data-id="element-387" data-mp="1kermzvzqcndv">
                  {i + 1}
                </span>
                <h3 className="font-display text-2xl font-semibold uppercase tracking-[0.04em]" data-id="element-388" data-mp="8z3177y7puen">{s.title}</h3>
                <p className="mt-1.5 text-titanium" data-id="element-389" data-mp="2kpuc7fkdv5jl">{s.body}</p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}